import React, { useState } from 'react';
import './PromotionButton.css';
import Container from '../Container';

const PromotionButton = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <Container>
      <div className="promotion-section">
        <p className="promotion-text">
          Para conocer más sobre nuestras promociones y ofertas especiales, por favor haga clic en el siguiente botón
        </p>
        <button 
          className="promotion-button"
          onClick={() => setIsModalOpen(true)}
        >
          Ver promociones
        </button>

        {isModalOpen && (
          <div className="modal-overlay" onClick={() => setIsModalOpen(false)}>
            <div className="modal-content" onClick={e => e.stopPropagation()}>
              <button 
                className="modal-close"
                onClick={() => setIsModalOpen(false)}
              >
                ×
              </button>
              <div className="modal-scroll">
                <h2>REGLAMENTO DE LA PROMOCIÓN POR OCTUBRE</h2>
                <div className="promotion-rules">
                  <h3>1. Aplicación de la promoción</h3>
                  <p>La promoción aplica en compras superiores a ₡45.000.</p>

                  <h3>2. Beneficio 2x1</h3>
                  <p>
                    Al adquirir dos productos participantes, el cliente recibirá
                    completamente gratis el producto de menor valor.
                  </p>

                  <h3>3. Productos participantes</h3>
                  <p>
                    Aplica en lentes sencillos digitales Maddox y lentes progresivos
                    Clarity, Max o life, según la lista de precios vigente.
                  </p>

                  <h3>4. Restricciones</h3>
                  <p>
                    No aplica en paquetes promocionales ni puede combinarse con otras
                    promociones, beneficios o descuentos.
                  </p>

                  <h3>5. Medios de pago</h3>
                  <p>
                    La promoción no aplica para pagos mediante Tasa Cero de Credomatic.
                    Se aceptan los siguientes medios de pago:
                  </p>
                  <ul>
                    <li>Credix a 3 o 6 meses.</li>
                    <li>Emma.</li>
                    <li>Otros medios de pago autorizados por Clínica Studio Visual.</li>
                  </ul>

                  <h3>6. Condiciones de pago</h3>
                  <p>
                    No se permiten apartados. Para procesar y enviar el pedido al
                    laboratorio, el cliente deberá cancelar como mínimo el 50% del
                    monto total.
                  </p>

                  <h3>7. Aplicación del beneficio</h3>
                  <p>
                    El beneficio se aplicará sobre el producto de menor valor. En caso
                    de que ambos productos tengan el mismo precio, uno de ellos será
                    completamente gratis.
                  </p>

                  <h3>8. Disponibilidad</h3>
                  <p>
                    La promoción está sujeta a disponibilidad de productos y a las
                    condiciones establecidas por Clínica Studio Visual.
                  </p>

                  <h3>9. Más información</h3>
                  <p>
                    Aplican restricciones. Para más información, el cliente puede
                    consultar en cualquiera de nuestras sucursales o comunicarse al{" "}
                    <a
                      href="https://wa.me/50687218585?text=Hola!%20Vengo%20del%20sitio%20web%20y%20me%20gustar%C3%ADa%20conocer%20m%C3%A1s%20sobre%20la%20promoci%C3%B3n%202x1"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      8721-8585
                    </a>.
                  </p>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </Container>
  );
};

export default PromotionButton;